/**
 * Heuristic for a coarse-only location permission (iOS "Precise Location" off, Chrome Android
 * "Approximate"). Browsers do not expose the granted accuracy level, so a position stream whose
 * accuracy stays above the threshold for the whole confirm window counts as coarse. A timer is
 * used instead of counting fixes because watchPosition rarely fires again for a coarsened position.
 */
export function createCoarseLocationDetector({ thresholdM, confirmMs, onCoarse, schedule = setTimeout, cancel = clearTimeout }) {
    let timer = null;
    // set once the session is settled either way: a precise fix seen, or coarse reported
    let done = false;

    function cancelTimer() {
        if (timer !== null) {
            cancel(timer);
            timer = null;
        }
    }

    return {
        // a single fix at or below the threshold proves precise access for the rest of the session
        onFix(accuracy) {
            if (done || typeof accuracy !== 'number' || !Number.isFinite(accuracy) || accuracy <= 0) {
                return;
            }
            if (accuracy <= thresholdM) {
                done = true;
                cancelTimer();
                return;
            }
            if (timer === null) {
                timer = schedule(() => {
                    timer = null;
                    done = true;
                    onCoarse();
                }, confirmMs);
            }
        },
        // tracking stopped: drop a running window, the next coarse fix starts a new one
        stop: cancelTimer
    };
}
